import '../assets/NcRadioGroupButton-Clc-jv1L.css';
import { defineComponent, onMounted, computed } from "vue";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { u as useNcFormBox } from "./useNcFormBox-Djlh582y.mjs";
import { u as useInsideRadioGroup } from "./useNcRadioGroup-D6llQmAl.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcRadioGroupButton",
  props: {
    ariaLabel: null,
    label: null,
    value: null
  },
  setup(__props) {
    const props = __props;
    const labelId = createElementId();
    const radioGroup = useInsideRadioGroup();
    const { formBoxItemClass } = useNcFormBox();
    onMounted(() => radioGroup.value.register(true));
    const isChecked = computed(() => radioGroup?.value.modelValue === props.value);
    function onUpdate() {
      radioGroup.value.onUpdate(props.value);
    }
    return { __sfc: true, props, labelId, radioGroup, formBoxItemClass, isChecked, onUpdate };
  }
});
const radioGroupButton = "_radioGroupButton_a-Nv5";
const radioGroupButton__label = "_radioGroupButton__label_kSWEc";
const radioGroupButton__icon = "_radioGroupButton__icon_5JtGt";
const radioGroupButton_active = "_radioGroupButton_active_lz9Ch";
const style0 = {
  "material-design-icon": "_material-design-icon_Bt-OR",
  radioGroupButton,
  radioGroupButton__label,
  radioGroupButton__icon,
  radioGroupButton_active
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [{
    [_vm.$style.radioGroupButton_active]: _setup.isChecked
  }, _vm.$style.radioGroupButton, _setup.formBoxItemClass], on: { "click": _setup.onUpdate } }, [_vm.$scopedSlots.icon ? _c("div", { class: _vm.$style.radioGroupButton__icon }, [_vm._t("icon")], 2) : _vm._e(), _vm.label ? _c("div", { class: _vm.$style.radioGroupButton__label, attrs: { "id": _setup.labelId } }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c("input", { staticClass: "hidden-visually", attrs: { "aria-labelledby": _vm.label ? _setup.labelId : void 0, "aria-label": _vm.label ? void 0 : _vm.ariaLabel, "type": "radio" }, domProps: { "checked": _setup.isChecked, "value": _vm.value }, on: { "input": _setup.onUpdate } })]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcRadioGroupButton = __component__.exports;
export {
  NcRadioGroupButton as N
};
//# sourceMappingURL=NcRadioGroupButton-B3yurXxO.mjs.map
